<template>
    <div class="row" v-if="$store.state.ended">
        <h2>Inscrições encerradas.</h2>
        <p>Maiores informações: <a href="mailto:contato@hcsports.com.br">contato@hcsports.com.br</a></p>
    </div>
    <div class="row" v-else>
        <div class="col-md-12">
            <div class="panel panel-default">
                <div class="panel-heading">Formulário de inscrição</div>
                <div class="panel-body">
                    <form v-if="$store.state.loaded">
                        <div class="row" v-if="errors">
                            <div class="col-md-12" v-html="errors">

                            </div>
                        </div>
                            <div class="row">
                                <div class="col-md-12 has-required">
                                    <div class="checkbox">
                                        <label class="control-label">
                                            <input type="checkbox" value="1" v-model="aceito">
                                             ACEITO as regras do FESTIVAL PÉ NA PRAIA – São Miguel do Gostoso, presentes no REGULAMENTO GERAL do evento e a política de tratamento de dados, nos limites das finalidades institucionais da H C PRODUÇÕES E EVENTOS LTDA - HC SPORTS, organizadora do evento, observando o norteamento jurídico da Lei 13.709/2018 (LGPD).
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div class="row" style="margin-bottom: 3rem;">
                                <div class="col-md-12 has-required">
                                    <div class="checkbox">
                                        <label class="control-label">
                                            <input type="checkbox" value="1" v-model="aceitoVacina">
                                                Estou CIENTE que o FESTIVAL PÉ NA PRAIA – São Miguel do Gostoso é um evento EXCLUSIVO para vacinados contra a COVID-19 (exigência dos órgãos de saúde do RN). Sei também, que para validar a minha inscrição, preciso apresentar o meu CERTIFICADO DE VACINAÇÃO no ato da retirada do kit de participação. Ao realizar a inscrição no FESTIVAL PÉ NA PRAIA – São Miguel do Gostoso, CONCORDO com esta regra e tenho ciência que o descumprimento desta invalida o meu cadastro e a possibilidade de restituição do valor pago.
                                        </label>
                                    </div>
                                </div>
                            </div>
                        <div class="row">
                            <div class="col-md-12 has-required">
                                <div class="form-group">
                                    <label class="control-label" for="categoria">Categoria</label>
                                    <select class="form-control" id="categoria" v-model="inscricao.metadados.categoria">
                                        <option value=""></option>
                                        <option :key=index v-for="(item, index) in $store.state.inscricao.options.categoria" v-bind:value="index">
                                            {{ item }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <h3>Atleta 1</h3>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-5 has-required">
                                <div class="form-group"
                                     v-bind:class="formGroupClass($v, 'nome')">
                                    <label class="control-label" for="nome">Nome Completo</label>
                                    <input type="text" class="form-control" id="nome" v-model.trim="inscricao.nome"
                                           @input="$v.inscricao.nome.$touch()"
                                           maxlength="50"
                                           required="required">
                                    <span class="help-block"
                                          v-if="$v.inscricao.nome.$error && !$v.inscricao.nome.containsSpace">Digite o seu nome completo.</span>
                                </div>
                            </div>
                            <!-- <div class="col-md-2 has-required">
                                <div class="form-group">
                                    <label class="control-label" for="sexo">Sexo</label>
                                    <select class="form-control" id="sexo" v-model="inscricao.sexo">
                                        <option value="Feminino">Feminino</option>
                                        <option value="Masculino">Masculino</option>
                                    </select>
                                </div>
                            </div> -->
                            <div class="col-md-5 has-required">
                                <div class="form-group"
                                     v-bind:class="formGroupClass($v, 'email')">
                                    <label class="control-label" for="email">Email</label>
                                    <input type="email" class="form-control" id="email" v-model.trim="inscricao.email"
                                           @input="$v.inscricao.email.$touch()"
                                           maxlength="60"
                                           required="required">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4 has-required">
                                <div class="form-group"
                                     v-bind:class="formGroupClass($v, 'login')">
                                    <label class="control-label" for="login">Nome de usuário</label>
                                    <input type="text" class="form-control" id="login" v-model.trim="inscricao.login"
                                           @input="$v.inscricao.login.$touch()"
                                           required="required">
                                    <span class="help-block">
                                        Crie um nome de usuário. Exemplo: sou.tenista
                                    </span>
                                </div>
                            </div>
                            <div class="col-md-4 has-required">
                                <div class="form-group"
                                     v-bind:class="formGroupClass($v, 'senha')">
                                    <label class="control-label" for="senha">Senha</label>
                                    <input type="password" class="form-control" id="senha" v-model="inscricao.senha"
                                           @input="$v.inscricao.senha.$touch()"
                                           required="required">
                                </div>
                            </div>
                            <div class="col-md-4 has-required">
                                <div class="form-group"
                                     v-bind:class="formGroupClass($v, 'confirma_senha')">
                                    <label class="control-label" for="confirma_senha">Confirme a senha</label>
                                    <input type="password" class="form-control" id="confirma_senha"
                                           v-model="inscricao.confirma_senha"
                                           @input="$v.inscricao.confirma_senha.$touch()"
                                           required="required">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-2 has-required">
                                <div class="form-group">
                                    <label class="control-label" for="documento_tipo">Tipo de Documento</label>
                                    <select class="form-control" id="documento_tipo" v-model="inscricao.documento_tipo">
                                        <option value="CPF">CPF</option>
                                        <option value="Passaporte">Passaporte</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-3 has-required">
                                <div class="form-group"
                                     v-bind:class="formGroupClass($v, 'documento')">
                                    <label class="control-label" for="documento">{{ documentoLabel }}</label>
                                    <input type="text" class="form-control" id="documento"
                                           v-model.trim="inscricao.documento"
                                           v-mask="documentoMask"
                                           @input="setMaskedFieldState($v, 'documento')"
                                           required="required">
                                </div>
                            </div>
                            <div class="col-md-3 has-required">
                                <div class="form-group"
                                     v-bind:class="formGroupClass($v, 'nascimento')">
                                    <label class="control-label" for="nascimento">
                                        Data de Nascimento
                                    </label>
                                    <input type="text" class="form-control" id="nascimento"
                                           v-model.trim="inscricao.nascimento"
                                           v-mask="'##/##/####'"
                                           placeholder="dia/mês/ano"
                                           @input="$v.inscricao.nascimento.$touch()"
                                           required="required">
                                    <span class="help-block"
                                          v-if="$v.inscricao.nascimento.$error && !$v.inscricao.nascimento.idade">
                                        Idade mínima: {{ idadeMinima }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-2">
                                <div class="form-group"
                                     v-bind:class="formGroupClass($v, 'telefone')">
                                    <label class="control-label" for="telefone">Telefone</label>
                                    <input type="text" class="form-control" id="telefone"
                                           v-model.trim="inscricao.telefone"
                                           v-mask="telefoneMask"
                                           @input="setMaskedFieldState($v, 'telefone')">
                                </div>
                            </div>
                            <div class="col-md-2 has-required">
                                <div class="form-group"
                                     v-bind:class="formGroupClass($v, 'celular')">
                                    <label class="control-label" for="celular">Celular</label>
                                    <input type="text" class="form-control" id="celular"
                                           v-model.trim="inscricao.celular"
                                           v-mask="celularMask"
                                           required="required"
                                           @input="setMaskedFieldState($v, 'celular')">
                                </div>
                            </div>
                            <div class="col-md-2 has-required">
                                <div class="form-group"
                                     v-bind:class="formGroupClass($v, 'cep')">
                                    <label class="control-label" for="cep">CEP</label>
                                    <input type="text" class="form-control" id="cep" v-model.trim="inscricao.cep"
                                           @input="$v.inscricao.cep.$touch()" v-mask="'##.###-###'"
                                           required="required">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">&nbsp;</label>
                                    <p id="loading" class="form-control form-control--text-only"><em>Informe o CEP para
                                        preencher o endereço automaticamente.</em></p>
                                </div>
                            </div>
                        </div>
                        <div id="container-endereco" class="container--overlay">
                            <div class="overlay" v-bind:class="{shown: loadingCep}" id="cep-overlay"><img
                                src="../assets/loading.svg"></div>
                            <div class="row">
                                <div class="col-md-6 has-required">
                                    <div class="form-group"
                                         v-bind:class="formGroupClass($v, 'logradouro')">
                                        <label class="control-label" for="logradouro">Logradouro</label>
                                        <input type="text" class="form-control" id="logradouro"
                                               v-model.trim="inscricao.logradouro"
                                               @input="$v.inscricao.logradouro.$touch()"
                                               required="required">
                                    </div>
                                </div>
                                <div class="col-md-2 has-required">
                                    <div class="form-group"
                                         v-bind:class="formGroupClass($v, 'numero')">
                                        <label class="control-label" for="nome">Número</label>
                                        <input type="text" class="form-control" id="numero"
                                               v-model.trim="inscricao.numero"
                                               maxlength="20"
                                               @input="$v.inscricao.numero.$touch()"
                                               required="required">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group"
                                        v-bind:class="formGroupClass($v, 'complemento')">
                                        <label class="control-label" for="complemento">Complemento</label>
                                        <input type="text" class="form-control" id="complemento"
                                               maxlength="40"
                                               @input="$v.inscricao.complemento.$touch()"
                                               v-model.trim="inscricao.complemento">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-5 has-required">
                                    <div class="form-group"
                                         v-bind:class="formGroupClass($v, 'bairro')">
                                        <label class="control-label" for="bairro">Bairro</label>
                                        <input type="text" class="form-control" id="bairro"
                                               v-model.trim="inscricao.bairro"
                                               maxlength="60"
                                               @input="$v.inscricao.bairro.$touch()"
                                               required="required">
                                    </div>
                                </div>
                                <div class="col-md-4 has-required">
                                    <div class="form-group"
                                         v-bind:class="formGroupClass($v, 'cidade')">
                                        <label class="control-label" for="cidade">Cidade</label>
                                        <input type="text" class="form-control" id="cidade"
                                               v-model.trim="inscricao.cidade"
                                               maxlength="50"
                                               @input="$v.inscricao.cidade.$touch()"
                                               required="required">
                                    </div>
                                </div>
                                <div class="col-md-3 has-required">
                                    <div class="form-group">
                                        <label class="control-label"
                                               for="uf">UF</label>
                                        <select class="form-control" id="uf" v-model="inscricao.uf">
                                            <option value="AC" selected="selected">Acre</option>
                                            <option value="AL">Alagoas</option>
                                            <option value="AM">Amazonas</option>
                                            <option value="AP">Amapá</option>
                                            <option value="BA">Bahia</option>
                                            <option value="CE">Ceará</option>
                                            <option value="DF">Distrito Federal</option>
                                            <option value="ES">Espírito Santo</option>
                                            <option value="GO">Goiás</option>
                                            <option value="MA">Maranhão</option>
                                            <option value="MT">Mato Grosso</option>
                                            <option value="MS">Mato Grosso do Sul</option>
                                            <option value="MG">Minas Gerais</option>
                                            <option value="PA">Pará</option>
                                            <option value="PB">Paraíba</option>
                                            <option value="PR">Paraná</option>
                                            <option value="PE">Pernambuco</option>
                                            <option value="PI">Piauí</option>
                                            <option value="RJ">Rio de Janeiro</option>
                                            <option value="RN">Rio Grande do Norte</option>
                                            <option value="RO">Rondônia</option>
                                            <option value="RS">Rio Grande do Sul</option>
                                            <option value="RR">Roraima</option>
                                            <option value="SC">Santa Catarina</option>
                                            <option value="SE">Sergipe</option>
                                            <option value="SP">São Paulo</option>
                                            <option value="TO">Tocantins</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4 has-required">
                                <div class="form-group">
                                    <label class="control-label"
                                           for="distancia">Camiseta</label>
                                    <select class="form-control" id="camiseta" v-model="inscricao.metadados.camiseta"
                                            @change="$v.inscricao.metadados.camiseta.$touch()">
                                        <option value="">Escolha um tamanho de camiseta</option>
                                        <option :key=index v-for="(item, index) in $store.state.inscricao.options.camiseta" v-bind:value="index">
                                            {{ item }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label" for="equipe">Equipe</label>
                                    <input type="text" class="form-control" id="equipe"
                                           v-model.trim="inscricao.metadados.equipe">
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <h3>Atleta 2</h3>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 has-required">
                                <div class="form-group"
                                     v-bind:class="formGroupClass($v, 'metadados.atleta2_nome')">
                                    <label class="control-label" for="atleta2_nome">Nome Completo</label>
                                    <input type="text" class="form-control" id="atleta2_nome" v-model.trim="inscricao.metadados.atleta2_nome"
                                           @input="$v.inscricao.metadados.atleta2_nome.$touch()"
                                           maxlength="50"
                                           required="required">
                                </div>
                            </div>
                            <div class="col-md-3 has-required">
                                <div class="form-group"
                                     v-bind:class="formGroupClass($v, 'metadados.atleta2_cpf')">
                                    <label class="control-label" for="atleta2_cpf">CPF</label>
                                    <input type="text" class="form-control" id="atleta2_cpf" v-model.trim="inscricao.metadados.atleta2_cpf"
                                           @input="$v.inscricao.metadados.atleta2_cpf.$touch()"
                                           v-mask="maskCpf"
                                           required="required">
                                </div>
                            </div>
                            <div class="col-md-3 has-required">
                                <div class="form-group"
                                     v-bind:class="formGroupClass($v, 'metadados.atleta2_email')">
                                    <label class="control-label" for="atleta2_email">Email</label>
                                    <input type="text" class="form-control" id="atleta2_email" v-model.trim="inscricao.metadados.atleta2_email"
                                           @input="$v.inscricao.metadados.atleta2_email.$touch()"
                                           required="required">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4 has-required">
                                <div class="form-group"
                                     v-bind:class="formGroupClass($v, 'metadados.atleta2_celular')">
                                    <label class="control-label" for="celular">Celular</label>
                                    <input type="text" class="form-control" id="atleta2_celular"
                                           v-model.trim="inscricao.metadados.atleta2_celular"
                                           v-mask="fixedCelularMask"
                                           required="required">
                                </div>
                            </div>
                            <div class="col-md-4 has-required">
                                <div class="form-group">
                                    <label class="control-label"
                                           for="atleta2_camiseta">Camiseta</label>
                                    <select class="form-control" id="atleta2_camiseta" v-model="inscricao.metadados.atleta2_camiseta">
                                        <option value="">Escolha um tamanho de camiseta</option>
                                        <option :key=index v-for="(item, index) in $store.state.inscricao.options.camiseta" v-bind:value="index">
                                            {{ item }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group text-right">
                                    <button type="submit" class="btn btn-primary btn-lg"
                                            v-on:click="inscricaoSave"
                                            v-bind:disabled="$v.$invalid || sending">
                                        <span class="glyphicon glyphicon-ok"></span> Enviar
                                    </button>
                                    <span class="help-block" v-show="$v.$invalid || !aceito">É preciso preencher o formulário corretamente e aceitar o regulamento para efetuar a inscrição.</span>
                                    <span class="help-block" v-show="sending">Processando, por favor aguarde...</span>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {required, email, minLength, maxLength, sameAs} from 'vuelidate/lib/validators'
    import cep from 'cep-promise'
    import $ from 'jquery'
    import toastr from 'toastr'
    var throttle = require('lodash.throttle')
    var CPF = require('cpf_cnpj').CPF
    var moment = require('moment')
    var slugify = require('slugify')
    moment.locale('pt-BR')
    var vex = require('vex-js/src/vex.combined')
    vex.defaultOptions.className = 'vex-theme-default'
    const validaCpf = function (val) {
        if (val === '') return true
        return CPF.isValid(val)
    }
    var acdInfo = `
    <p>De acordo com a Lei 12.933/2013 o atleta deve apresentar a documentação necessária a comprovação da deficiência: Laudo Técnico emitido pela CORDE e o Laudo Médico que originou o enquadramento como PCD.</p>
    <p>A CORDE é um órgão vinculado a Secretaria Estadual da Justiça e da Cidadania - SEJUC, que trata das políticas públicas voltadas exclusivamente às pessoas com deficiência no Estado do Rio Grande do Norte.</p>
`

    export default {
        props: ['editMode'],
        data: function () {
            return {
                currentIdadeMinima: 18,
                idadeMinima: 14,
                idade5: 14,
                idade10: 16,
                idadeAdulto: 18,
                sending: false,
                errors: false,
                aceito: false,
                aceitoVacina: false,
                loadingCep: false,
                maskCpf: '###.###.###-##',
                telefoneMask: '',
                celularMask: '',
                fixedCelularMask: '(##) #####-####',
                documentoMask: '',
                documentoLabel: '',
                inscricao: {
                    email: '',
                    login: '',
                    senha: '',
                    confirma_senha: '',
                    nome: '',
                    documento: '',
                    documento_tipo: 'CPF',
                    telefone: '',
                    celular: '',
                    nascimento: '',
                    especial: '',
                    cep: '',
                    logradouro: '',
                    numero: '',
                    complemento: '',
                    bairro: '',
                    cidade: '',
                    uf: 'RN',
                    metadados: {
                        camiseta: '',
                        equipe: '',
                        categoria: '',

                        atleta2_nome: '',
                        atleta2_cpf: '',
                        atleta2_email: '',
                        atleta2_celular: '',
                        atleta2_camiseta: ''
                    }
                }

            }
        },
        mounted: function () {
            this.adjustDocumentoField()
            if (this.$store.state.ended && !sessionStorage.getItem('popupShown')) {
                sessionStorage.setItem('popupShown', '1')
                const encerradoInfo = `
                    <div style="padding: 4rem">
                        <h2>Inscrições encerradas.</h2>
                        <p>Maiores informações: <a href="mailto:contato@hcsports.com.br">contato@hcsports.com.br</a></p>
                    </div>
                `
                vex.dialog.alert({unsafeMessage: encerradoInfo})
            }
        },
        methods: {
            showAcd: function (evt) {
                evt.preventDefault()
                vex.dialog.alert({unsafeMessage: acdInfo})
            },
            getIdade: function (val) {
                return moment('31-12-' + new Date().getFullYear(), 'DD-MM-YYYY').diff(moment(val, 'DD-MM-YYYY'), 'years')
            },
            inscricaoSave: function (evt) {
                evt.preventDefault()
                this.inscricao.evento_id = this.$store.state.evento_id
                this.sending = true
                let diz = this
                $.ajax({
                    url: process.env.BACKEND_URL.CREATE,
                    method: 'POST',
                    data: this.inscricao,
                    success: function (data, textStatus, jqXHR) {
                        diz.$store.dispatch('login', {token: data.access_token}).then(function (data, textStatus, jqXHR) {
                            diz.$store.commit('assignInfo', data)
                        })
                        toastr.success('Seus dados foram salvos.')
                    },
                    error: function (data, textStatus, jqXHR) {
                        toastr.error(data.responseText)
                    },
                    complete: function (data, textStatus, jqXHR) {
                        diz.sending = false
                    },
                    dataType: 'JSON'
                })
            },
            formGroupClass: function ($v) {
                for (let i in arguments) {
                    if (typeof arguments[i] !== 'string') {
                        continue
                    }
                    var isMetadados = arguments[i].indexOf('.')
                    var el
                    if (isMetadados >= 0) {
                        el = $v.inscricao.metadados[arguments[i].substr(isMetadados + 1)]
                    } else {
                        el = $v.inscricao[arguments[i]]
                    }

                    if (el.$error) {
                        return 'has-error'
                    } else if (el.$dirty && !el.$error) {
                        return 'has-success'
                    }
                }
                return false
            },
            adjustDocumentoField: function () {
                if (this.inscricao.documento_tipo === 'CPF') {
                    this.documentoLabel = 'CPF'
                    this.documentoMask = '###.###.###-##'
                } else {
                    this.documentoLabel = 'Passaporte'
                    this.documentoMask = ''
                }
            },
            setMaskedFieldState: function ($v, field) {
                if (this.inscricao[field].length) {
                    $v.inscricao[field].$touch()
                }
            },
            throttledCep: throttle(function (val) {
                this.loadingCep = true
                var diz = this
                toastr.info('Carregando informações para o CEP ' + val + '.')
                cep(val).then(function (data) {
                    toastr.success('Informações obtidas com sucesso.')
                    diz.loadingCep = false

                    diz.inscricao.uf = data.state
                    diz.inscricao.cidade = data.city
                    diz.inscricao.bairro = data.neighborhood
                    diz.inscricao.logradouro = data.street
                    diz.$v.inscricao.cidade.$touch()
                    diz.$v.inscricao.bairro.$touch()
                    diz.$v.inscricao.logradouro.$touch()

                    document.getElementById('numero').focus()
                }, function () {
                    diz.loadingCep = false
                    toastr.error('Não foi possível carregar as informações do CEP.')
                    toastr.warning('Por favor, informe seu endereço manualmente.')
                })
            }, 3000)
        },
        watch: {
            'inscricao.login': function (val) {
                this.inscricao.login = slugify(val.toLowerCase(), '.').replace('..', '.')
            },
            'inscricao.email': function (val) {
                this.inscricao.email = val.toLowerCase()
            },
            'inscricao.nome': function (val) {
                this.inscricao.nome = val.toUpperCase().replace('  ', ' ')
            },
            'inscricao.logradouro': function (val) {
                this.inscricao.logradouro = val.toUpperCase().replace('  ', ' ')
            },
            'inscricao.numero': function (val) {
                this.inscricao.numero = val.toUpperCase().replace('  ', ' ')
            },
            'inscricao.complemento': function (val) {
                this.inscricao.complemento = val.toUpperCase().replace('  ', ' ')
            },
            'inscricao.bairro': function (val) {
                this.inscricao.bairro = val.toUpperCase().replace('  ', ' ')
            },
            'inscricao.cidade': function (val) {
                this.inscricao.cidade = val.toUpperCase().replace('  ', ' ')
            },
            'inscricao.documento_tipo': function (val) {
                this.adjustDocumentoField()
            },
            'inscricao.telefone': function (val) {
                if (this.inscricao.telefone.length <= 14) {
                    this.telefoneMask = '(##) ####-#####'
                } else {
                    this.telefoneMask = '(##) #####-####'
                }
            },
            'inscricao.celular': function (val) {
                if (this.inscricao.celular.length <= 14) {
                    this.celularMask = '(##) ####-#####'
                } else {
                    this.celularMask = '(##) #####-####'
                }
            },
            'inscricao.cep': function (val) {
                if (!this.$v.inscricao.cep.$error) {
                    this.throttledCep(val)
                }
            },
            'inscricao.metadados.equipe': function (val) {
                this.inscricao.metadados.equipe = val.toUpperCase().replace('  ', ' ')
            },
            'inscricao.metadados.atleta2_nome': function (val) {
                this.inscricao.metadados.atleta2_nome = val.toUpperCase().replace('  ', ' ')
            },
            'inscricao.metadados.atleta3_nome': function (val) {
                this.inscricao.metadados.atleta3_nome = val.toUpperCase().replace('  ', ' ')
            },
            'inscricao.metadados.atleta4_nome': function (val) {
                this.inscricao.metadados.atleta4_nome = val.toUpperCase().replace('  ', ' ')
            },
            'inscricao.metadados.atleta5_nome': function (val) {
                this.inscricao.metadados.atleta5_nome = val.toUpperCase().replace('  ', ' ')
            },
            'inscricao.metadados.atleta6_nome': function (val) {
                this.inscricao.metadados.atleta6_nome = val.toUpperCase().replace('  ', ' ')
            }
        },
        validations: {
            semMulheresSuficientes: {
                mulheres: function (val) {
                    return val !== true
                }
            },
            aceito: {
                required
            },
            aceitoVacina: {
                required
            },
            inscricao: {
                login: {
                    required
                },
                email: {
                    required,
                    email,
                    maxLength: maxLength(60)
                },
                senha: {
                    required,
                    minLength: minLength(4)
                },
                confirma_senha: {
                    sameAs: sameAs('senha')
                },
                nome: {
                    required,
                    maxLength: maxLength(50),
                    containsSpace: function (val) {
                        if (val === '') return true
                        return !!val.match(/\S+\s\S+/)
                    }
                },
                documento: {
                    required,
                    cpf: function (val) {
                        if (val === '') return true
                        if (this.inscricao.documento_tipo === 'CPF') {
                            return CPF.isValid(val)
                        }
                        return true
                    }
                },
                telefone: {
                    minLength: minLength(14)
                },
                celular: {
                    required,
                    minLength: minLength(14)
                },
                nascimento: {
                    required,
                    minLength: minLength(10),
                    data: function (val) {
                        if (val === '') return true
                        if (val.length === 10) {
                            let m = moment(val, 'DD-MM-YYYY')
                            return m.isValid()
                        }
                        return false
                    },
                    idade: function (val) {
                        if (val === '') return true
                        if (val.length === 10) {
                            return this.getIdade(val) >= this.idadeMinima
                        }
                        return false
                    }
                },
                cep: {
                    required,
                    minLength: minLength(10),
                    maxLength: maxLength(10)
                },
                logradouro: {
                    required
                },
                numero: {
                    required,
                    maxLength: maxLength(20)
                },
                complemento: {
                    maxLength: maxLength(40)
                },
                bairro: {
                    required,
                    maxLength: maxLength(60)
                },
                cidade: {
                    required,
                    maxLength: maxLength(50)
                },
                metadados: {
                    camiseta: {
                        required
                    },
                    categoria: {
                        required
                    },
                    atleta2_nome: {
                        required
                    },
                    atleta2_email: {
                        required
                    },
                    atleta2_cpf: {
                        required,
                        cpf: validaCpf
                    },
                    atleta2_celular: {
                        required,
                        minLength: minLength(14)
                    },
                    atleta2_camiseta: {
                        required
                    }
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Inscricao.vue